
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { Button } from "../../Components/Button.js";
import { RouterModule_encodeParts, RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { singleton, empty, toArray, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { TableContainer } from "../../Widgets/Container.js";
import { Table } from "../../Widgets/Table/Table.js";
import { OnTableRowClick$1, ColumnDefinition$1, CellContent } from "../../Widgets/Table/Types.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import { Skeleton } from "../../Components/Skeleton.js";

export function OverviewTable(props) {
    let elems_2, elems_1, elems, TableRows;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "grow"])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "mb-3", "justify-items-end"])], (elems_1 = [reactElement("div", {
        className: join(" ", ["grow"]),
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["justify-self-end"])], (elems = [createElement(Button, {
        ComponentState: "enabled",
        Label: t("procedure_template.overview.create_new_button_title"),
        OnClick: () => {
            RouterModule_nav(ofArray(["procedure-templates", "new"]), 1, 1);
        },
        TestId: "procedure-template-overview-new-checklist-button",
        Variant: "primary",
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement(TableContainer, {
        Content: createElement(Table, (TableRows = toArray(props.ProcedureTemplates), {
            ColumnDefinitions: [new ColumnDefinition$1("title", "", t("general.title"), (dto) => (new CellContent(0, [dto.Title])), "text", "text"), new ColumnDefinition$1("description", "", t("general.description"), (dto_1) => (new CellContent(0, [dto_1.Description])), "text", "text"), new ColumnDefinition$1("state", "", t("procedure.form.state"), (dto_2) => {
                let matchValue;
                return new CellContent(0, [(matchValue = dto_2.State, (matchValue.tag === 2) ? t("procedure.state.released") : ((matchValue.tag === 1) ? t("procedure.state.archived") : t("procedure.state.draft")))]);
            }, "select", "text"), new ColumnDefinition$1("createdAt", "", t("general.created_at"), (dto_3) => (new CellContent(6, [dto_3.CreatedAt])), "dateRange", "date")],
            Controls: empty(),
            Options: {
                BorderStyle: "full",
                CSVDownload: false,
                ConfigurableColumns: false,
                CustomTableFilters: false,
                DefaultColumnFilter: singleton({
                    id: "state",
                    value: [t("procedure.state.released"), t("procedure.state.draft")],
                }),
                DefaultSortColumn: ["createdAt", "desc"],
                Fullscreen: false,
                GlobalSearch: false,
                OnRowClick: new OnTableRowClick$1(1, [(procedureTemplate) => RouterModule_encodeParts(ofArray(["procedure-templates", procedureTemplate.Id]), 1)]),
                RowSelection: "disabled",
                SaveTableConfiguration: false,
            },
            TableKey: "procedure-templates-overview",
            TableRows: TableRows,
        })),
    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function OverviewView() {
    const matchValue = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), undefined, undefined)[0].ProcedureTemplates;
    if (matchValue.tag === 0) {
        return createElement(Skeleton, {
            Variant: "table",
        });
    }
    else {
        return createElement(OverviewTable, {
            ProcedureTemplates: matchValue.fields[0],
        });
    }
}

